import config from '../../../config';
import { ReauthWarning, ResolveReauthWarningParams, StartFederatedLoginParams } from './sso.types';

const SSO_REDIRECT_PATH_STORAGE_KEY = 'sso-redirect-path';
const FEDERATED_SESSION_ACTIVE_STORAGE_KEY = 'federated-session-active';
const MILLISECONDS_IN_MINUTE = 60_000;
const REAUTH_WARNING_STEP_IN_MINUTES = 5;
const REAUTH_MODAL_STEP_IN_MINUTES = 10;

export const storeSsoRedirectPath = (redirectPath: string) => {
  sessionStorage.setItem(SSO_REDIRECT_PATH_STORAGE_KEY, redirectPath);
};

export const consumeSsoRedirectPath = (): string | null => {
  const redirectPath = sessionStorage.getItem(SSO_REDIRECT_PATH_STORAGE_KEY);
  sessionStorage.removeItem(SSO_REDIRECT_PATH_STORAGE_KEY);
  return redirectPath;
};

export const startFederatedLogin = ({ brandSlug, redirectPath }: StartFederatedLoginParams) => {
  storeSsoRedirectPath(redirectPath);
  window.location.assign(`${config.baseURL}/auth/sso/${encodeURIComponent(brandSlug)}/start`);
};

export const computeReauthMinutesRemaining = (deadline: string, now: Date): number =>
  Math.max(0, Math.ceil((new Date(deadline).getTime() - now.getTime()) / MILLISECONDS_IN_MINUTE));

export const resolveReauthWarning = ({
  deadline,
  minutesRemaining,
  lastWarning,
}: ResolveReauthWarningParams): ReauthWarning | null => {
  const mark =
    Math.ceil(minutesRemaining / REAUTH_WARNING_STEP_IN_MINUTES) * REAUTH_WARNING_STEP_IN_MINUTES;
  const lastWarnedMark = lastWarning?.deadline === deadline ? lastWarning.mark : undefined;

  if (mark === 0 || mark === lastWarnedMark) {
    return null;
  }

  const isFirstWarning = lastWarnedMark === undefined;
  const isModalMark = mark % REAUTH_MODAL_STEP_IN_MINUTES === 0;

  return { deadline, mark, kind: isFirstWarning || isModalMark ? 'modal' : 'snackbar' };
};

export const markFederatedSessionActive = () => {
  localStorage.setItem(FEDERATED_SESSION_ACTIVE_STORAGE_KEY, 'true');
};

export const isFederatedSessionActive = (): boolean =>
  localStorage.getItem(FEDERATED_SESSION_ACTIVE_STORAGE_KEY) === 'true';

export const clearFederatedSessionFlag = () => {
  localStorage.removeItem(FEDERATED_SESSION_ACTIVE_STORAGE_KEY);
};
